import React, { useEffect, useState, useContext, useRef } from "react";
import styled from "styled-components";
import DashHeader from "../components/DashHeader";
import Footer from "../components/Footer";
import {
  ENABLE_BT_SCANNER_TRACKING
} from "../data/application.properties";
import {
  SSOSettingsPage,
  ManageKiosksPage,
  ManageUsersPage,
  ManageSitesPage,
  AboutPage,
  LicenseSummary,
  DeviceRegistrationPage,
  AdminManagerSummaryBoardContainer,
  SitesDashboard,
  AccessPointsDashboard,
  DevicesDashboard,
  Workflow,
  LostDevicePage,
  AnalyticsDeviceUtilizationDetailReportPage,
  AnalyticsDeviceUtilizationSummaryReportPage,
  AnalyticsDailyEventDetailReportPage,
  AnalyticsDailyEventSummaryReportPage,
  SnapshotAdminReportPage,
  SnapshotManagerReportPage,
  ListByEventReport,
  Notifications,
  GPSLocationPage,
  DeviceMovement,
  KioskDevicePage
} from "../pages";
import { SisenseDashboardContainer } from "../pages/reports/sisenseReports/sisenseDashboardContainer";
import { DataProvider } from "../data/DataContext";
import { Route, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DeviceDetails from "../pages/Dashboard/DeviceDetails";
import BTScannersPage from "../pages/btscanners/Settings"
import { AuthContext } from "../authentication/Auth";
import MultiMenus from "../routing/MultiMenus";
import { menuLinks } from "./menuLinks";
import { managerMenuLinks } from "./managerMenuLinks";
import EventCategoryPage from "../pages/reports/drilldowneventreport";
import MachineLearningPage from "../pages/MachineLearningPage";
// import CSVImport from "../pages/CsvImport";
// import CompatibilityNotificationModal from '../components/modals/CompatibilityNotificationModal';
import { TENANT_ID } from "../data/application.properties";
import app from "../authentication/firebaseStart";
import DeviceReportsPage from "../pages/reports/devices/DeviceReportsPage";
const firestore = app.firestore();

const MainWrapper = styled.div`
  justify-content: start;
  display: flex;
  flex-direction: row;
  padding: 32px 0;
  background-color: #f2f2f2;
  min-height: 100%;
  max-width: 100%;

  @media screen and (max-width: 750px) {
    flex-direction: column;
    padding: 15px 8px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 16px;
  width: 75%;
  height: fit-content;
  overflow-x: auto;

  @media screen and (max-width: 1200px) {
    margin-right: 24px;
    width: calc(100% - 24px);
  }

  @media screen and (max-width: 750px) {
    width: 100%;
  }
`;

function SiteRouter(props) {
  let location = useLocation();
  const [currentPageName, setCurrentPageName] = useState("");

  /*
  * To Restrict manager sidebar menu
  */
  const [isManager, setIsManager] = useState(false);
  const [userSidebarMenu, setUserSidebarMenu] = useState(menuLinks);
  const { currentUser } = useContext(AuthContext);
  const context = useContext(AuthContext);
  const [listDropDown, setListDropDown] = useState("");
  const [selectedTitle, setTitle] = useState("");
  const { t } = useTranslation()
  // DLR flag
  const [dlrFeatureFlag, setDlrFeatureFlag] = useState(false);

  const fetchDLRFlagInfo = async () => {
    let data = (
      await firestore
        .collection("tenants")
        .doc(TENANT_ID)
        .collection("Configuration")
        .doc("AppSettings")
        .get()
    ).data();

    if (data) {
      if(data.featureToggling?.dlrPrediction && data.featureToggling?.dlrPrediction == 1){
        setDlrFeatureFlag(true);
      }
    }
  }

  useEffect(() => {
    fetchDLRFlagInfo();
  }, []);

  addRemoveBTScannerTracking();

  //const {globalAppSettings } = useContext(DataContext);

  // const compatibilityNotificationRef = useRef();
  //let localSSOlogin = JSON.parse(localStorage.getItem("ssoLogin"));
  //console.log("sidebar localSSOlogin", localSSOlogin);

  // useEffect(()=>{
  //   let compatibilityNotification = localStorage.getItem("compatibilityNotification")
  //   if(compatibilityNotification){
  //     compatibilityNotificationRef.current.open()
  //   }
  // },[])

  // useEffect(() => {
  //   if(!localSSOlogin && menuLinks[2].link !== "/manage-users") {
  //     menuLinks.splice(2,0,{ label :"menu.manageUsers",link:"/manage-users", "dividerNeeded": true });
  //     //console.log(menuLinks,'TestMenuLinks after splice')
  //   }

  // }, [localSSOlogin]);

  // Need to show manage-users for both Non-SSO and SSO modes
  /*useEffect(() => {
    if(menuLinks[2].link !== "/manage-users") {
      menuLinks.splice(2,0,{ label :"menu.manageUsers",link:"/manage-users", "dividerNeeded": true });
      //console.log(menuLinks,'TestMenuLinks after splice')
    }
  }, [localSSOlogin]);*/

  function getMenuLinksForCompanyUser() {
    return menuLinks.map(link => {
      if(link?.link === "/dashboard" && link.submenu?.length > 0){
        return {
          ...link,
          submenu: link.submenu.filter(submenu => {
            return submenu?.link !== "/dashboard/license-summary"
          })
        }
      }
      if(link?.link === '/settings'){
        return {
          ...link,
          submenu: link.submenu.filter(submenu => {
            return submenu?.link !== "/settings/device-registration"
          })
        }
      }
      return link;
    })
  }

  useEffect(() => {
    setCurrentPageName(getCurrentPageName(location.pathname));
    setPageTitle(currentPageName);

    setUserSidebarMenu(menuLinks);

    //console.log(currentUser,'currentUser')
    if (currentUser) {
      const {isManager, isCompanyUser} = context.currentUser.claims;
      console.log(isManager, ' isManager');
      if (isManager) {
        setUserSidebarMenu(managerMenuLinks);
      } else if(isCompanyUser){
        const companyUserMenuLinks = getMenuLinksForCompanyUser()
        setUserSidebarMenu(companyUserMenuLinks);
      }
      setIsManager(isManager);
    }
  }, [location.pathname, currentPageName,menuLinks]); // eslint-disable-line react-hooks/exhaustive-deps

  function addRemoveBTScannerTracking(){
    console.log('BT Scanner Tracking :', ENABLE_BT_SCANNER_TRACKING);
    const enableBTTracking = (ENABLE_BT_SCANNER_TRACKING==0)?false:true;
    var menu = menuLinks.find(({ label }) => label === "menu.settings");
    if(!enableBTTracking){
      var index = menu?.submenu?.findIndex(({ label }) => label === "menu.subMenu.btScanners");
      if(-1!==index){
        menu?.submenu?.splice(index,1);
      }
    }else {
      if(-1 === menu?.submenu?.findIndex(({ label }) => label === "menu.subMenu.btScanners")){
        menu?.submenu?.push(
          {
            "label": "menu.subMenu.btScanners",  // menu label displayed under Settings in Web Portal
            "link": "/settings/btscanners"
          });
      }
    }

  }


  function getCurrentPageName(path) {

    let currentPage;
    menuLinks.forEach(menu => {
      if(menu.link === path) {
        currentPage = menu;
      }
      else if(menu?.submenu) {
         menu.submenu.forEach( sub => {
          if(sub?.submenu) {

            if(sub?.submenu[0]?.link === path) {
              currentPage = sub?.submenu[0];
            }

          }
          else {
            if(sub.link === path)
              currentPage = sub;
          }
        })

      }
    });


    //console.log(currentPage,'currentPage')

    if(path === "/dashboard/devicedetail") {
      currentPage = "Device details";
      return currentPage;
    }
    else {
      return currentPage ? currentPage.label : "NOT FOUND";
    }

  }

  function setPageTitle(pageName) {
    document.title = t('deviceTracker') + " " + t(pageName);
  }

  //console.log(userSidebarMenu,'userSidebarMenu')
  return (
    <DataProvider>
      {/* <CompatibilityNotificationModal modalRef={compatibilityNotificationRef} /> */}
      <DashHeader />
      <MainWrapper>
        <MultiMenus menus={userSidebarMenu} />
        {/* <Sidebar sections={userSidebarMenu}></Sidebar> */}
        <ContentWrapper>
          {isManager ?
            <>
              <Route path="/dashboard/summary-dashboard">
                <AdminManagerSummaryBoardContainer
                  listDropDown={listDropDown}
                  setListDropDown={setListDropDown}
                  selectedTitle={selectedTitle}
                  setTitle={setTitle}
                />
              </Route>
              <Route path="/dashboard/aps">
                <AccessPointsDashboard />
              </Route>
              <Route path="/dashboard/devicedetail">
                <DeviceDetails />
              </Route>

              <Route path="/dashboard/deviceslist/:devicetype">
                <DevicesDashboard
                  listDropDown={listDropDown}
                  setListDropDown={setListDropDown}
                  selectedTitle={selectedTitle}
                  setTitle={setTitle}
                />
              </Route>
              <Route path="/settings/kiosk-device">
                <KioskDevicePage />
              </Route>
              <Route path="/settings/manage-kiosk">
                <ManageKiosksPage />
              </Route>
              <Route path="/settings/site">
                <ManageSitesPage />
              </Route>
              <Route path="/settings/manage-users">
                <ManageUsersPage />
              </Route>
              <Route path="/reports/device-utilization-detail">
                <AnalyticsDeviceUtilizationDetailReportPage />
              </Route>
              <Route path="/reports/device-utilization-summary">
                <AnalyticsDeviceUtilizationSummaryReportPage />
              </Route>
              <Route path="/reports/daily-event-detail-report">
                <AnalyticsDailyEventDetailReportPage />
              </Route>
              <Route path="/reports/daily-event-summary-report">
                <AnalyticsDailyEventSummaryReportPage />
              </Route>
              <Route path="/reports/end-of-day-summary">
                <SnapshotAdminReportPage />
              </Route>
              <Route path="/reports/end-of-day-detail">
                <SnapshotManagerReportPage />
              </Route>
              <Route path="/reports/historical-reports">
                <SisenseDashboardContainer />
              </Route>
              <Route path="/reports/site-event">
                <ListByEventReport />
              </Route>
              <Route path="/reports/device-movement">
                <DeviceMovement />
              </Route>
              <Route path="/reports/summary-by-category">
                <EventCategoryPage />
              </Route>
              <Route path="/about">
                <AboutPage />
              </Route>
              <Route path="/reports/devices">
                <DeviceReportsPage />
              </Route>
            </>
            :
            <>
              <Route path="/reports/devices">
                <DeviceReportsPage />
              </Route>
              <Route path="/reports/device-utilization-detail">
                <AnalyticsDeviceUtilizationDetailReportPage />
              </Route>
              <Route path="/reports/device-utilization-summary">
                <AnalyticsDeviceUtilizationSummaryReportPage />
              </Route>
              <Route path="/reports/daily-event-detail-report">
                <AnalyticsDailyEventDetailReportPage />
              </Route>
              <Route path="/reports/daily-event-summary-report">
                <AnalyticsDailyEventSummaryReportPage />
              </Route>
              <Route path="/reports/end-of-day-summary">
                <SnapshotAdminReportPage />
              </Route>
              <Route path="/reports/end-of-day-detail">
                <SnapshotManagerReportPage />
              </Route>
              <Route path="/reports/site-event">
                <ListByEventReport />
              </Route>
              <Route path="/reports/device-movement">
                <DeviceMovement />
              </Route>
              <Route path="/reports/summary-by-category">
                <EventCategoryPage />
              </Route>
              <Route path="/reports/historical-reports">
                <SisenseDashboardContainer />
              </Route>
              <Route path="/dashboard/summary-dashboard">
                <AdminManagerSummaryBoardContainer
                  listDropDown={listDropDown}
                  setListDropDown={setListDropDown}
                  selectedTitle={selectedTitle}
                  setTitle={setTitle}
                />
              </Route>
              <Route path="/dashboard/aps">
                <AccessPointsDashboard />
              </Route>
              <Route path="/dashboard/devicedetail">
                <DeviceDetails />
              </Route>
              <Route path="/dashboard/deviceslist/:devicetype">
                <DevicesDashboard
                  listDropDown={listDropDown}
                  setListDropDown={setListDropDown}
                  selectedTitle={selectedTitle}
                  setTitle={setTitle}
                />
              </Route>

              <Route path="/dashboard/license-summary">
                <LicenseSummary />
              </Route>
              <Route path="/settings/kiosk-device">
                <KioskDevicePage />
              </Route>
              <Route path="/settings/manage-kiosk">
                <ManageKiosksPage />
              </Route>
              <Route path="/settings/site">
                {/* <SitesDashboard /> */}
                <ManageSitesPage />
              </Route>
              <Route path="/settings/manage-users">
                <ManageUsersPage />
              </Route>
              <Route path="/settings/btscanners">
                <BTScannersPage />
              </Route>
              <Route path="/settings/gps-location">
                <GPSLocationPage />
              </Route>
              <Route path="/settings/ssoint/sso">
                <SSOSettingsPage />
              </Route>
              <Route path="/about">
                <AboutPage />
              </Route>
              {/* <Route path="/import">
                <CSVImport />
              </Route> */}
              <Route path="/settings/device-registration">
                <DeviceRegistrationPage />
              </Route>
              { dlrFeatureFlag ? 
                <Route path="/settings/auto/workflow-automation"><Workflow /> </Route>
                :
                <Route path="/settings/workflow-automation"> <Workflow /> </Route>
              }
              <Route path="/settings/auto/MachineLearning">
                <MachineLearningPage />
              </Route>
              <Route path="/settings/notifications">
                <Notifications />
              </Route>

            </>
          }
        </ContentWrapper>
      </MainWrapper>
      <Footer translation={t} />
    </DataProvider>
  );
}

export default SiteRouter;